export default __webpack_public_path__ + "static/media/4.2cf794a9.png";